<!-- 表单模型管理 -->
<template>
<el-dialog width="60%" :destroy-on-close="true" top="10vh" :append-to-body="true" :visible.sync='procModelVersion.show' title="流程版本设置">
  <div class="formModel">
    <easyCruds
      ref="mainTable"
      :tableInfo="mainTable"
      @mainTableReload="mainTableReload"
    >
    </easyCruds>
    <!-- 编辑、新增表单模型 -->
    <settingQueryMoudle ref="settingQueryMoudle" :settingQueryMoudle="settingQueryMoudle"></settingQueryMoudle>
  </div>
  <span slot="footer">
    <el-button type="danger"  @click="procModelVersion.show = false">取 消</el-button>
    <el-button type="primary" @click="setProcVersion">确 定</el-button>
        </span>
</el-dialog>
</template>

<script>
import settingQueryMoudle from './settingQueryMoudle'
export default {
  props: ['procModelVersion'],
  data() {
    return {
      mainTable: {
        // header: { title: '表单模型管理' },
        buttonSetting: {
          allowAdd: false,
          allowEdit: false,
          allowView: false,
          allowDelete: false,
          left: [

          ]
        },
        table: {
          loading: false,
          height: 600,
          stripe: true,
          conditionLabelWidth: '100px',
          selection: true,
          index: false,
          columns: [
            // NAME_,KEY_,VERSION_
            {
              prop: 'NAME_',
              label: '流程名称',
              view: [false, false, true],
              disabled: [true, true, true]
            // isSearchCondition: true
            }, {
              prop: 'KEY_',
              label: '流程key',
              view: [false, false, true],
              disabled: [true, true, true]
            // isSearchCondition: true
            }, {
              prop: 'VERSION_',
              view: [false, false, true],
              disabled: [true, true, true],
              label: '流程版本'
            }],
          operation: {
            width: '220',
            operations: []
          },
          tableData: [],
          paging: {
            currentPage: 1,
            pageSizes: [15, 20, 25, 30],
            pageSize: 15,
            total: 0
          },
          reload: 'mainTableReload',
          reloadConditions: {}
        }
      }
    }
  },
  components: {
    settingQueryMoudle
  },
  // activated() {
  //   this.mainTableReload()
  // },
  mounted: function() {
    // this.mainTableReload()
  },
  methods: {
    Initialize() {
      this.mainTableReload()
    },
    mainTableReload: function(params = { pageSize: 15, pageNum: 1 }) {
      this.mainTable.table.loading = true
      this.$http.get('/flow-ext/query-version-by-form-id', {
        params: Object.assign(params, { formId: this.procModelVersion.formId })
      }).then(response => {
        this.mainTable.table.loading = false
        response.data.records.forEach(item => {
          if (item.procDefId) {
            item.procDefId = item.procDefId.split(':')[0] + ':' + item.procDefId.split(':')[1]
          }
        })
        this.mainTable.table.tableData = response.data.records
        this.mainTable.table.paging.total = response.data.total || response.data.records.length
      }).catch(error => {
        this.mainTable.table.loading = false
        this.$message.error(error.msg || error.message)
      })
    },
    /** 查看绑定值查询 */
    setProcVersion() {
      let optionRow = this.$refs.mainTable.getSelectedRows()
      if (optionRow.length === 0) {
        this.$message({ message: '请选中一条记录再操作哟。', type: 'warning' })
        return false
      } else if (optionRow.length >= 2) {
        this.$message({ message: '只能选择一行记录进行操作哟', type: 'warning' })
        return false
      }
      this.mainTable.table.loading = true
      this.$http.put('/form-model/version-proc-set', null, {
        params: { formVersionId: this.procModelVersion.id, procDefId: optionRow[0].ID_ }
      }).then(response => {
        this.mainTable.table.loading = false
        this.procModelVersion.show = false
        this.$emit('Initialize')
      }).catch(error => {
        this.mainTable.table.loading = false
        this.$message.error(error.msg || error.message)
      })
    }

  }
}
</script>
<style lang='scss' scoped>
</style>
